import React from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
    children: React.ReactNode;
}

export const DocumentBodyPortal: React.FC<PortalProps> = ({children}) => {
    return createPortal(children, document.body);
}